import React from "react";
import { render } from "react-dom";
import { MarkdownProvider } from "@/providers";
import { IframeProvider } from "@/core/providers/iframeProvider";
import { classNamePrefix as prefixCt } from "@/utils/common";
import { IframeView } from "@/citadel-pc/components/Iframe";
import "../index.less";

const getContent = (node) => {
  let content = "";
  if (node.dataset.content !== undefined) {
    content = node.dataset.content;
  } else {
    const $code = node.querySelector("code");
    if ($code) {
      content = $code.textContent;
    }
  }
  return content;
};

// 浏览态新开窗口打开a标签，其他元素点击保持默认行为
const handleClick = (fakeEvt) => {
  if (fakeEvt.target.tagName.toUpperCase() === "A") {
    const url = fakeEvt.target.href;

    if (url) {
      window.open(url);
    }
  }
};

const noop = () => {};

const loadMarkdownScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src =
      "https://cdn.bootcdn.net/ajax/libs/markdown-it/8.4.2/markdown-it.min.js";
    script.onload = () => {
      resolve("ok");
    };
    document.head.appendChild(script);
  });
};

export default class markdownRender {
  fragmentCls: string;

  config: Record<string, any>;

  provider: IframeProvider;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("markdown")}`;
    this.config = config;
    this.provider = new MarkdownProvider();
  }

  preprocess = async ($container) => {
    if (
      !(window as any).markdownit &&
      $container.querySelector(this.fragmentCls)
    ) {
      await loadMarkdownScript();
    }
  };

  fragmentRender = (node: HTMLElement) => {
    const MarkdownIt = (window as any).markdownit({
      html: true,
      highlight(str, lang) {
        if (lang && hljs.getLanguage(lang)) {
          try {
            return hljs.highlight(lang, str).value;
          } catch (__) {
            noop();
          }
        }
        return "";
      },
    });

    const content = getContent(node);
    const htmlContent = MarkdownIt.render(content);
    const newNode = document.createElement("div");
    newNode.className = prefixCt("markdown");
    newNode.setAttribute("data-content", content);
    render(
      <IframeView
        key={content}
        attrs={{ content }}
        htmlContent={htmlContent}
        type="markdown"
        view={null}
        getPos={() => 0}
        node={null}
        provider={this.provider}
        handleClick={handleClick}
        dom={null}
      />,
      newNode
    );

    node.parentNode.replaceChild(newNode, node);
  };
}
